













































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'Question526',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswer: null,
        language: 'fr',
      },
      options: [
        {text: 'a', value: 'a'},
        {text: 'b', value: 'b'},
        {text: 'c', value: 'c'},
      ],
    };
  },
  computed: {
    imageName(): string {
      return prefixPublicAsset('/img/assignments/q526_main.png');
    },
    imageAName(): string {
      return prefixPublicAsset('/img/assignments/q526_choiceA.png');
    },
    imageBName(): string {
      return prefixPublicAsset('/img/assignments/q526_choiceB.png');
    },
    imageCName(): string {
      return prefixPublicAsset('/img/assignments/q526_choiceC.png');
    },
  },
};
